// Stale-deploy recovery: a deploy replaces hashed chunks, so a tab opened before it 404s
// its next chunk and Vite fires `vite:preloadError`. Reload once to fetch the new build.

const RELOAD_FLAG_KEY = 'chunkErrorReloaded';

const alreadyReloaded = (): boolean => {
  try {
    return sessionStorage.getItem(RELOAD_FLAG_KEY) === '1';
  } catch {
    return false;
  }
};

// false = storage blocked; with no flag surviving the reload we can't stop a loop, so skip it.
const markReloaded = (): boolean => {
  try {
    sessionStorage.setItem(RELOAD_FLAG_KEY, '1');
    return true;
  } catch {
    return false;
  }
};

export const installChunkErrorReload = (): (() => void) => {
  const handler = (event: Event) => {
    if (alreadyReloaded()) return; // one auto-reload per tab session; then let the error surface
    if (!markReloaded()) return;
    event.preventDefault(); // stop Vite rethrowing into the route errorElement
    window.location.reload();
  };
  window.addEventListener('vite:preloadError', handler);
  return () => window.removeEventListener('vite:preloadError', handler);
};
